import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { href: "/", label: "홈" },
  { href: "/about", label: "학원소개" },
  { href: "/notice", label: "공지사항 및 시간표" },
  { href: "/materials", label: "학습자료실" },
  { href: "/videos", label: "동영상 자료실" },
  { href: "/location", label: "오시는 길" },
];

export default function Navbar() {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`sticky top-0 z-50 transition-all duration-300 border-b ${
        scrolled
          ? "bg-white/95 backdrop-blur-sm shadow-sm border-slate-100"
          : "bg-white border-slate-100"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 group">
            <img
              src="https://1e9smb8.atoms.world/assets/fma-logo.png"
              alt="FMA수학학원 로고"
              className="h-10 w-auto group-hover:scale-105 transition-transform"
            />
            <span className="text-xl font-bold text-[#1E3A5F]">
              FMA<span className="text-[#2563EB]">수학</span>학원
            </span>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden lg:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`px-3 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                  location.pathname === link.href
                    ? "bg-[#2563EB]/10 text-[#2563EB]"
                    : "text-slate-600 hover:text-[#1E3A5F] hover:bg-slate-50"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* Mobile hamburger */}
          <button
            className="lg:hidden w-10 h-10 flex items-center justify-center text-slate-600 hover:text-[#1E3A5F] cursor-pointer"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="메뉴 열기"
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
          </button>
        </div>

        {/* Mobile Menu */}
        {menuOpen && (
          <div className="lg:hidden py-3 border-t border-slate-100">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`block px-4 py-2.5 text-sm font-medium rounded-lg mb-1 transition-colors ${
                  location.pathname === link.href
                    ? "bg-[#2563EB]/10 text-[#2563EB]"
                    : "text-slate-600 hover:bg-slate-50"
                }`}
                onClick={() => setMenuOpen(false)}
              >
                {link.label}
              </Link>
            ))}
          </div>
        )}
      </div>
    </nav>
  );
}
